(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ctrl-news-radar-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeRadar = (root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const list = root.querySelector('[data-radar-list]');
      if (!list) return;
      const entries = Array.from(list.querySelectorAll('[data-radar-entry]'));
      const compact = root.dataset.compact === 'true';
      const limit = Number(root.dataset.limit) || 3;
      const countrySelect = root.querySelector('[data-radar-country]');
      const filter = root.querySelector('[data-radar-filter]');
      const result = root.querySelector('[data-radar-result]');
      const empty = root.querySelector('[data-radar-empty]');

      entries.sort((first, second) => {
        // El archivo conserva su contexto; las fechas ausentes nunca se inventan.
        const archiveDifference = Number(Boolean(first.dataset.archiveYear)) - Number(Boolean(second.dataset.archiveYear));
        if (archiveDifference) return archiveDifference;
        return second.dataset.sourceDate.localeCompare(first.dataset.sourceDate);
      });
      entries.forEach((entry) => list.appendChild(entry));

      const applyFilter = () => {
        const selectedCountry = countrySelect?.value || 'all';
        let visibleCount = 0;
        entries.forEach((entry) => {
          const matches = selectedCountry === 'all' || entry.dataset.country === selectedCountry;
          const show = matches && (!compact || visibleCount < limit);
          entry.hidden = !show;
          if (show) visibleCount += 1;
        });
        if (result) {
          const pattern = visibleCount === 1 ? root.dataset.resultOne : root.dataset.resultOther;
          result.textContent = pattern.replace('__COUNT__', String(visibleCount));
        }
        if (empty) empty.hidden = visibleCount > 0;
      };

      if (countrySelect && filter) {
        const countries = new Map();
        entries.forEach((entry) => countries.set(entry.dataset.country, entry.dataset.countryLabel));
        Array.from(countries.entries()).sort((first, second) => first[1].localeCompare(second[1])).forEach(([value, label]) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = label;
          countrySelect.appendChild(option);
        });
        filter.hidden = false;
        countrySelect.addEventListener('change', applyFilter);
      }
      applyFilter();
    };

    const initializeAll = () => document.querySelectorAll('[data-radar]').forEach(initializeRadar);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ctrl-wholesale-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialogId = 'CtrlWholesale';
    const wholesalePath = /\/pages\/mayoristas\/?$/;
    let trigger = null;

    const isWholesaleLink = (element) => {
      if (element instanceof HTMLAnchorElement) {
        const url = new URL(element.href, window.location.href);
        if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return false;
        return element.hasAttribute('data-ctrl-wholesale') || wholesalePath.test(url.pathname) || url.hash === '#mayoristas';
      }
      return element.hasAttribute('data-ctrl-wholesale');
    };

    const openWholesale = (dialog, source) => {
      trigger = source;
      // El menú libera su foco y el bloqueo de scroll antes de abrir el diálogo.
      const drawer = document.getElementById('ctrl-drawer');
      if (drawer?.classList.contains('is-on')) document.getElementById('ctrl-close')?.click();
      if (!dialog.open) dialog.showModal();
      const focusTarget = dialog.querySelector('[data-wholesale-result]') || dialog.querySelector('#CtrlWholesaleTitle');
      focusTarget?.focus({ preventScroll: true });
    };

    const restoreFocus = () => {
      const sourceIsVisible = trigger instanceof HTMLElement && trigger.isConnected &&
        !trigger.closest('[inert], [aria-hidden="true"]') && trigger.getClientRects().length > 0;
      if (sourceIsVisible) {
        trigger.focus({ preventScroll: true });
        return;
      }
      const burger = document.getElementById('ctrl-burg');
      const fallback = burger?.getClientRects().length ? burger : document.querySelector('.ctrl-hd__brand');
      fallback?.focus({ preventScroll: true });
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const dialog = document.getElementById(dialogId);
      if (!(dialog instanceof HTMLDialogElement)) return;
      const link = event.target.closest('[data-ctrl-wholesale], a[href]');
      if (link && isWholesaleLink(link) && event.button === 0 &&
          !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        event.preventDefault();
        openWholesale(dialog, link);
        return;
      }
      if (event.target.closest('[data-wholesale-close]')) dialog.close();
      if (event.target === dialog) {
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right ||
            event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }
    });

    const openForCurrentLocation = (dialog) => {
      const fromWholesalePage = wholesalePath.test(window.location.pathname);
      const fromWholesaleHash = window.location.hash === '#mayoristas';
      const fromFormResult = dialog.querySelector('[data-wholesale-result]');
      // Solo Shopify decide si hubo éxito; la URL por sí sola nunca crea una confirmación.
      if (fromWholesalePage || fromWholesaleHash || fromFormResult) openWholesale(dialog, null);
    };

    const initializeWholesale = () => {
      const dialog = document.getElementById(dialogId);
      if (!(dialog instanceof HTMLDialogElement) || dialog.dataset.initialized) return;
      dialog.dataset.initialized = 'true';
      dialog.addEventListener('close', restoreFocus);
      openForCurrentLocation(dialog);
    };

    window.addEventListener('hashchange', () => {
      const dialog = document.getElementById(dialogId);
      if (dialog instanceof HTMLDialogElement) openForCurrentLocation(dialog);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeWholesale, { once: true });
    else initializeWholesale();
    document.addEventListener('shopify:section:load', initializeWholesale);
  })();
  } catch(e) { console.error(e); }
})();

})();
